// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__v30tt","text":"SelectPayment_text__2x2q6","title":"SelectPayment_title__3ogEP","btn":"SelectPayment_btn__21EaS"};